
























import { Vue, Component } from 'vue-property-decorator';
import { firebaseConfig } from '@/utils/firebase';

import Modal from '@/components/Modal.vue';
import firebase from 'firebase/app';
import 'firebase/auth';

import '@/assets/app.css';

@Component({
    components: {
        Modal
    }
})
export default class App extends Vue {
    intent!: string;
    fetching = true;

    signOut() {
        this.$store.dispatch('signOut');
    }

    mounted() {
        if (!firebase.apps.length) firebase.initializeApp(firebaseConfig);

        const { commit } = this.$store;

        firebase.auth().onAuthStateChanged((user) => {
            commit('setUser', user);

            this.fetching = false;
            const { path } = this.$route;

            if (user) {
                // successful connection

                const targetRoute = this.intent || '/';

                if (path !== targetRoute) {
                    this.$router.push(targetRoute);
                    // dispatch('loadAllProfiles');
                }
            } else {
                // need to log in
                if (path !== '/' && path !== '/sign-in') {
                    commit('setIntent', path);
                }
                if (path !== '/sign-in') this.$router.push('/sign-in');
            }
        });
    }
}
